class ResponsiveSectionGate extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector('template');
    this.mount = this.querySelector('[data-responsive-section-mount]');
    if (!this.template) return;

    if (!this.mount) {
      this.mount = document.createElement('div');
      this.mount.setAttribute('data-responsive-section-mount', '');
      this.appendChild(this.mount);
    }
    this.mount.style.display = 'contents';

    this.onChange = this.onChange.bind(this);
    this.mediaQuery = window.matchMedia(this.buildQuery());
    this.onChange(this.mediaQuery);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onChange);
    } else {
      this.mediaQuery.addListener(this.onChange);
    }
  }

  disconnectedCallback() {
    if (!this.mediaQuery || !this.onChange) return;

    if (this.mediaQuery.removeEventListener) {
      this.mediaQuery.removeEventListener('change', this.onChange);
    } else {
      this.mediaQuery.removeListener(this.onChange);
    }
  }

  buildQuery() {
    const breakpoint = Number.parseInt(this.dataset.breakpoint || '768', 10);
    const renderOn = this.dataset.renderOn;

    if (renderOn === 'mobile') {
      return `(max-width: ${breakpoint - 1}px)`;
    }

    return `(min-width: ${breakpoint}px)`;
  }

  onChange(event) {
    if (event.matches) {
      this.mountContent();
    } else {
      this.unmountContent();
    }
  }

  mountContent() {
    if (this.mounted || !this.template || !this.mount) return;

    this.mount.appendChild(this.template.content.cloneNode(true));
    this.mounted = true;
    this.afterMutation();
  }

  unmountContent() {
    if (!this.mounted || !this.mount) return;

    this.cleanupMountedContent();
    this.mount.replaceChildren();
    this.mounted = false;
    this.afterMutation();
  }

  cleanupMountedContent() {
    this.mount.querySelectorAll('auto-swiper').forEach((element) => {
      element.swiper?.destroy?.(true, true);
    });

    if (!window.ScrollTrigger) return;

    window.ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.trigger && this.mount.contains(trigger.trigger)) {
        trigger.kill();
      }
    });
  }

  afterMutation() {
    window.requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('responsive-section-gate:change', {
        detail: { gate: this, mounted: this.mounted },
      }));

      if (window.ScrollTrigger) {
        window.ScrollTrigger.refresh();
      }
    });
  }
}

if (!window.customElements.get('responsive-section-gate')) {
  window.customElements.define('responsive-section-gate', ResponsiveSectionGate);
}
